import { File, FileText, Sheet } from 'lucide-react';
import { fileKind } from './categories';

/** The icon for a document, by its file type. */
export function FileKindIcon({ fileName, size = 18 }: { fileName: string; size?: number }) {
    switch (fileKind(fileName)) {
        case 'pdf': return <FileText size={size} aria-hidden="true" />;
        case 'doc': return <FileText size={size} aria-hidden="true" />;
        case 'sheet': return <Sheet size={size} aria-hidden="true" />;
        case 'text': return <FileText size={size} aria-hidden="true" />;
        default: return <File size={size} aria-hidden="true" />;
    }
}
